import { Sparkles } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Progress } from '@/components/ui/progress'
import { ListingImportBlueprint } from '@/components/deals/ListingImportBlueprint'

const WAIT_LIMIT_MS = 35_000

export function ListingImportProgress({
  elapsedMs,
  hasExceededWait,
  hasPollingError,
  onOpenDeal,
  onStayOnPipeline,
}) {
  const progress = Math.min(92, Math.max(12, Math.round((elapsedMs / WAIT_LIMIT_MS) * 92)))

  return (
    <div className="space-y-6 p-6" role="status" aria-live="polite">
      <div className="flex flex-col items-center text-center">
        <Badge variant="secondary" className="mb-5 uppercase tracking-widest">
          <Sparkles /> Blueprint Import
        </Badge>

        <ListingImportBlueprint />
        <span className="mt-2 text-xs font-semibold uppercase tracking-widest text-primary">
          Building property profile
        </span>
        <h3 className="mt-2 text-lg font-bold text-foreground">Importing listing…</h3>
        <p className="mt-1 text-sm text-muted-foreground">
          Turning source data into your Sentinel deal
        </p>
      </div>

      <Progress value={progress} aria-label="Listing import progress" />

      {hasPollingError ? (
        <p className="rounded-lg border border-border bg-muted/30 p-3 text-center text-xs text-muted-foreground">
          Progress is taking longer to refresh. Sentinel will keep checking.
        </p>
      ) : null}

      {hasExceededWait ? (
        <div className="space-y-3 border-t border-border pt-5">
          <p className="text-center text-sm text-muted-foreground">
            Import is still running. You can open the deal now or stay on the pipeline.
          </p>
          <Button type="button" className="w-full" onClick={onOpenDeal}>
            Open deal while importing
          </Button>
          <Button type="button" variant="outline" className="w-full" onClick={onStayOnPipeline}>
            Stay on pipeline
          </Button>
        </div>
      ) : null}
    </div>
  )
}
